module.exports = __webpack_public_path__ + "static/media/md-cloud-circle.60e4a811.svg";